import React, { Component } from "react";
import fileDownload from "js-file-download";
import {
  getIcsCalendar,
  getYahooCalendarUrl,
  getGoogleCalendarUrl,
  getMicrosoftCalendarUrl
} from "./Helper";
import "../../../assets/less/components/addToCalendar.less";

class AddToCalendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
  }

  componentDidMount = () => {};

  handleCalendarClick = () => {
    const fileName =
      this.props.appointment.title.replace(/[^\w ]+/g, "") + ".ics";
    fileDownload(
      getIcsCalendar(this.props.appointment),
      fileName,
      "application/octet-stream"
    );
  };

  handleToggleOptions = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };
  render() {
    return (
      <div className="add-to-calendar-container hidden-print">
        <div className="top-panel" onClick={this.handleToggleOptions}>
          Add to Calendar
          <i className="material-icons">keyboard_arrow_down</i>
        </div>
        {this.state.isOpen ? (
          <ul className="add-to-calendar-list">
            <li>
              <a onClick={this.handleCalendarClick}>iCalendar</a>
            </li>
            <li>
              <a
                href={getGoogleCalendarUrl(this.props.appointment)}
                target="_blank"
              >
                Google Calendar
              </a>
            </li>
            <li>
              <a onClick={this.handleCalendarClick}>Outlook</a>
            </li>
            <li>
              <a
                href={getYahooCalendarUrl(this.props.appointment)}
                target="_blank"
              >
                Yahoo! Calendar
              </a>
            </li>
            <li>
              <a
                href={getMicrosoftCalendarUrl(this.props.appointment)}
                target="_blank"
              >
                Microsoft Calendar
              </a>
            </li>
          </ul>
        ) : null}
      </div>
    );
  }
}

export { AddToCalendar };



// WEBPACK FOOTER //
// ./src/modules/Confirm/components/AddToCalendar.js